mmf_modules.define('app/tos/index',['require','exports','module','jquery','api/tos','api/userTOSAcceptance','app/tos/view','context_vars/utils/user'],function (require, exports, module) {

  var $ = require('jquery');
  var tos = require('api/tos');
  var tosAcceptance = require('api/userTOSAcceptance');
  var view = require('app/tos/view');
  var ctx_user = require('context_vars/utils/user');

  exports.init = function () {

    if (ctx_user.is_anonymous) {
      return;
    }

    tosAcceptance.get(ctx_user.id)
      .done(function (data, textStatus, jqxhr) {
        tos.get(data._links.tos[0].id)
          .done(function (data, textStatus, jqxhr) {
            if (data.is_latest) {
              return $.Deferred().resolve();
            } else {
              tos.getLatest()
                .done(view.render);
            }
          });
      })
      .fail(function (jqxhr, textStatus, errorThrown) {
        if (jqxhr.status === 404) {
          tos.getLatest()
            .done(view.render);
        }
      });

  };

});

